var _excluded = ["context"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { autoUpdate, flip, offset, shift, size, useClick, useDismiss, useFloating, useInteractions, useListNavigation, useRole, useTypeahead } from '@floating-ui/react';
import React, { useContext, useRef, useState } from 'react';
export var useBaseMenu = _ref => {
  var {
    isOpen,
    onOpenChange: setIsOpen,
    width,
    disableMenuShift,
    disableTypeahead,
    role = 'menu'
  } = _ref;

  var _useFloating = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-start',
    middleware: [offset({
      mainAxis: 8,
      alignmentAxis: 0
    }), size({
      apply: _ref2 => {
        var {
          rects
        } = _ref2;
        data.refs.floating.current && !width && Object.assign(data.refs.floating.current.style, {
          width: "".concat(rects.reference.width, "px")
        });
      }
    }), flip(), !disableMenuShift && shift()],
    whileElementsMounted: autoUpdate
  }),
      {
    context
  } = _useFloating,
      data = _objectWithoutProperties(_useFloating, _excluded);

  var [activeIndex, setActiveIndex] = useState(null);
  var elementsRef = useRef([]);
  var labelsRef = useRef([]);
  var listNavigation = useListNavigation(context, {
    listRef: elementsRef,
    activeIndex,
    onNavigate: setActiveIndex,
    loop: true
  });
  var typeahead = useTypeahead(context, {
    listRef: labelsRef,
    activeIndex,
    onMatch: setActiveIndex,
    enabled: !disableTypeahead
  });
  var click = useClick(context);
  var menuRole = useRole(context, {
    role
  });
  var dismiss = useDismiss(context);
  var interactions = useInteractions([click, menuRole, dismiss, listNavigation, typeahead]);
  return _objectSpread(_objectSpread(_objectSpread({}, data), interactions), {}, {
    activeIndex,
    setActiveIndex,
    elementsRef,
    labelsRef,
    context,
    isOpen,
    setIsOpen
  });
};
export var BaseMenuContext = /*#__PURE__*/React.createContext({});
export var useBaseMenuContext = () => useContext(BaseMenuContext);
//# sourceMappingURL=useBaseMenu.js.map